import { startup } from 'library-@/startup/index.js';
import { headerService } from '@/services/header-service';

export async function startupView(forceSetLocale?: string) {
    const [, locale, , commonInitData, , legalConfig] = await startup({
        headerService,
        projectName: 'Patent View',
        pageInit: () => ({}),
        redirect: '/request_demo?project=search',
        forceSetLocale: forceSetLocale,
    });

    return {
        commonInitData,
        locale,
        legalConfig,
    };
}
